export default __webpack_public_path__ + "static/media/rostoFelizIcone.66c6efb9.svg";